const RestaurantCategoryTemplate = ({ name }) => {
  return `
  <div class="category">${name}</div>
  `
}

export default RestaurantCategoryTemplate
